export const BOT_TYPE = {
  NONE: 'None',
  VERSION1: 'Legacy (v1)',
  VERSION2: 'QnaBot - Floating (v2)',
  VERSION3_1: 'ReactBot - Floating (v3.1)',
  VERSION3_2: 'ReactBot - Sidebar (v3.2)',
}
